import React from 'react';

import { createExpanderCell } from '../../../webcommon/grid/gridcomponents';

import TitleCell from './CustomCells/TitleCell';
import HeaderCell from './CustomCells/HeaderCell';

const RenderTitleCell = (row, alignRight, value) => (
    <TitleCell
        title={ row.original.title }
        value={ value || value === 0 ? value.toLocaleString() : '' }
        alignRight={ alignRight }
        titleRow={ row.original.titleRow === true }
        error={ row.original.error }
        status={ row.original.status }
        filtered={ row.original.filtered }
        typeRow={ row.original.typeRow }
    />
);

const SensitivtyComponent = createExpanderCell(() => null, undefined, (row, gridProps) => {
    gridProps.onExpanderClick(row);
});

// eslint-disable-next-line import/prefer-default-export
export const mappings = [
    {
        id: 'title',
        title: '',
        draggable: true,
        hideable: true,
        width: 200,
        noPadding: true,
        expander: true,
        renderCell: (row) => {
            if (row.original.typeRow) {
                if (row.original.children.length) {
                    const value = row.original.selected ? `${row.value}- ${row.original.type}` : row.value;
                    return <SensitivtyComponent { ...row } value={ value || '' } />;
                }
                return row.value || '';
            }
            return RenderTitleCell(row,
                false,
                row.original.titleRow ? `${row.original.title} - ${row.original.counterparty}` : row.original.title);
        }
    },
    {
        id: 'trades',
        title: 'No. Trades',
        draggable: true,
        hideable: true,
        noPadding: true,
        type: 'number',
        expander: true,
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                toolTipMessage="Number of trades in EOD IM Calculation"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.value)
    },
    {
        id: 'imThresholdCollect',
        title: 'IM Threshold Collect',
        draggable: true,
        hideable: true,
        noPadding: true,
        hasSymbol: true,
        expander: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Threshold Collect"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR' ? row.original.imThresholdCollectEur : row.original.imThresholdCollectUsd)
    },
    {
        id: 'imThresholdPost',
        title: 'IM Threshold Post',
        draggable: true,
        hideable: true,
        noPadding: true,
        hasSymbol: true,
        expander: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Threshold Post"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR' ? row.original.imThresholdPostEur : row.original.imThresholdPostUsd)
    },
    {
        id: 'imAmt',
        title: 'IM Amt',
        draggable: true,
        hideable: false,
        noPadding: true,
        hasSymbol: true,
        expander: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Amount calculated for EOD trades"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR'
            ? row.original.imAmountEur : row.original.imAmountUsd)
    },
    {
        id: 'imConf',
        title: 'IM Conf',
        draggable: true,
        hideable: false,
        noPadding: true,
        expander: true,
        hasSymbol: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Incremental impact for only confirmed trades booked today against CSA"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR' ? row.original.imAmountConfirmedEur : row.original.imAmountConfirmedUsd)
    },
    {
        id: 'imIncr',
        title: 'IM Incr',
        draggable: true,
        hideable: false,
        noPadding: true,
        hasSymbol: true,
        expander: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Incremental impact for only included (what-if) trades"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR' ? row.original.imAmountIncrementEur : row.original.imAmountIncrementUsd)
    },
    {
        id: 'imTotal',
        title: 'IM Total',
        draggable: true,
        hideable: false,
        noPadding: true,
        hasSymbol: true,
        expander: true,
        type: 'number',
        Header: header => (
            <HeaderCell
                value={ header.column.title }
                symbol={ header.column.getGridProps().symbol }
                toolTipMessage="IM Total amount calculated for EOD trades, trades booked today against CSA and included (what-if) trades"
            />
        ),
        renderCell: row => RenderTitleCell(row, true, row.column.getGridProps().symbol === 'EUR' ? row.original.imTotalEur : row.original.imTotalUsd)
    }
];
